import { CustomerServiceOutlined } from '@ant-design/icons'
import { FC } from 'react'
import type { CrmIntegrationAttachment } from '../../types/crm-integration-chat.types'
import {
  attachmentAudioDisplayName,
  attachmentAudioHref,
  formatCrmIntegrationAttachmentDuration,
} from '../../lib/crmIntegrationAttachment'
import classes from '../../styles/crmIntegrationChat.module.css'

type CrmIntegrationIncomingAudioProps = {
  att: CrmIntegrationAttachment
}

/** Музыкальный трек (kind=audio) — карточка + ссылка, не voice-плеер. */
const CrmIntegrationIncomingAudio: FC<CrmIntegrationIncomingAudioProps> = ({
  att,
}) => {
  if (att.kind !== 'audio') {
    return null
  }

  const label = attachmentAudioDisplayName(att)
  const durationLabel = formatCrmIntegrationAttachmentDuration(att.duration)
  const href = attachmentAudioHref(att)

  return (
    <div className={classes.bubbleAudioCard}>
      <div className={classes.bubbleAudioHeader}>
        <CustomerServiceOutlined
          className={classes.bubbleAudioIcon}
          aria-hidden
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
        <div className={classes.bubbleAudioMeta}>
          <span className={classes.bubbleAudioLabel}>{label}</span>
          {durationLabel ? (
            <span className={classes.bubbleAudioDuration}>{durationLabel}</span>
          ) : null}
        </div>
      </div>
      {href ? (
        <a
          className={classes.bubbleAttachmentLink}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          title={href}
        >
          {href}
        </a>
      ) : (
        <span className={classes.bubbleAttachmentLink}>Аудио недоступно</span>
      )}
    </div>
  )
}

export default CrmIntegrationIncomingAudio
